/* eslint-disable quote-props */
import { createHttpClient } from '../utils/httpUtils';
import * as Sentry from '@sentry/react';
class WeekCommitmentService {
  constructor() {
    this.http = createHttpClient();
  }

  async getActualOpenRange(projectId, scheduleId) {
    const date = new Date().getTime();
    const params = { date };
    const queryString = new URLSearchParams(params).toString();
    const endpoint = `weekcommitments/project/${projectId}/schedule/${scheduleId}/open-range`;

    const res = await this.http
      .get(`${endpoint}?${queryString}`)
      .catch((error) => {
        Sentry.captureException(error);
        throw error;
      });
    return res.data;
  }

  async show(weekCommitmentId) {
    const res = await this.http
      .get('weekcommitments/' + weekCommitmentId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async destroy(weekCommitmentId) {
    const res = await this.http
      .delete('weekcommitments/' + weekCommitmentId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async searchbyweek(data) {
    const res = await this.http
      .post('weekcommitments/searchbyweek/', data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async create(data) {
    const res = await this.http
      .post('weekcommitments/', data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async update(data) {
    const res = await this.http
      .put('weekcommitments/' + data.id, data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async searchBySector(sectorId) {
    const data = { sector_id: sectorId };
    const res = await this.http
      .post('weekcommitments/searchbysector/', data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async getByWeekly(data) {
    const res = await this.http
      .post('weekcommitments/getbyweekly', data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async getByWeeklyWidget(data) {
    const res = await this.http
      .post('weekcommitments/searchbyweekwidgetd', data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async getCurrentWeeklyPlan({ projectId, scheduleId }) {
    const date = new Date().getTime();
    const params = { date };
    const queryString = new URLSearchParams(params).toString();
    const endpoint = `weekcommitments/project/${projectId}/schedule/${scheduleId}/wwp/current`;
    const res = await this.http
      .get(`${endpoint}?${queryString}`)
      .catch((error) => {
        Sentry.captureException(error);
        throw error;
      });
    return res.data;
  }

  async getWeeklyPlanByNumber({ projectId, scheduleId, number }) {
    const params = { number };
    const endpoint = `weekcommitments/project/${projectId}/schedule/${scheduleId}/wwp`;
    const queryString = new URLSearchParams(params).toString();
    const res = await this.http
      .get(`${endpoint}?${queryString}`)
      .catch((error) => {
        Sentry.captureException(error);
        throw error;
      });
    return res.data;
  }
}

export const weekCommitmentService = new WeekCommitmentService();
